module.exports = __webpack_public_path__ + "media/new_ui/build-program-d880cefb.png";